import { useMedia } from 'react-use';

import type { Breakpoint } from '#src/style/mediaQuery.ts';
import { breakpoints } from '#src/style/mediaQuery.ts';

export const useScreenSize = (size: number | Breakpoint) => {
  let mediaQuery;
  if (typeof size === 'number') {
    mediaQuery = `(min-width: ${size}px)`;
  } else {
    mediaQuery = `(min-width: ${breakpoints[size]}px)`;
  }
  const up = useMedia(mediaQuery);

  return { up };
};
